import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentDetails } from 'models/payment-details';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from 'sharedServices/app-config.service';
import { DateOnly } from 'shared/base/generics/models/date-only';
import { AccountHolderTypes } from 'sharedEnums/account-holders';
import { ApiBaseService } from 'sharedServices/api-base.service';

@Injectable({
    providedIn: 'root',
})
export class PaymentService extends ApiBaseService {
    constructor(appConfig: AppConfigService, http: HttpClient) {
        super(appConfig, http);
    }

    addUpdatePayment(
        request: PaymentDetails,
        doAvsCheck: boolean = false,
        doBankConsentCall: boolean = false,
        isDropOffAnchorPoint: boolean = false,
    ): Observable<{
        avsAttempts: number;
        paymentDetails: PaymentDetails;
        paymentDetailsHistory: Array<PaymentDetails>;
        dropOffState?: any;
    }> {
        if (request.accountType?.code == 'C') {
            request = {
                ...request,
                accountNumber: request.creditCardNumber,
                accountHolderName: request.creditCardAccountHolderName,
            };
        }

        if (request.accountHolderType == AccountHolderTypes.ADDITIONAL_HOUSEHOLD_MEMBER) {
            request = {
                ...request,
                accountHolderType: AccountHolderTypes.HOUSEHOLD_MEMBER,
            };
        }

        return this.http
            .post<{
                avsAttempts: number;
                paymentDetails: PaymentDetails;
                paymentDetailsHistory: Array<PaymentDetails>;
                dropOffState?: any;
            }>(
                `${this.baseUrl()}/Payment/AddUpdatePaymentDetails?doAvsCheck=${doAvsCheck}&doBankConsentCall=${doBankConsentCall}&isDropOffAnchorPoint=${isDropOffAnchorPoint}`,
                request,
                {
                    headers: this.headers(),
                },
            )
            .pipe(
                map((res) => {
                    if (typeof res.paymentDetails.expiryDate === 'string') {
                        res.paymentDetails.expiryDate = new DateOnly(res.paymentDetails.expiryDate);
                    }
                    return res;
                }),
            );
    }
}
